// image-gallery.component.ts
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import {CdkDragHandle} from '@angular/cdk/drag-drop';
import { DragDropModule } from 'primeng/dragdrop';
import {CheckboxModule} from "primeng/checkbox";
import {FormsModule} from "@angular/forms";
import {ImageComponent} from "../image/image.component";
import {MenuItem} from "primeng/api";
import { ImageItem } from '@core/_utils/tools.utils';

@Component({
    selector: 'app-image-gallery',
    templateUrl: './images.component.html',
    styleUrls: ['./images.component.scss'],
    standalone: true,
    encapsulation: ViewEncapsulation.None,
    imports: [
        CdkDragHandle,
        CheckboxModule,
        FormsModule,
        DragDropModule,
        ImageComponent
    ]
})

export class ImageGalleryComponent {
    @Input() @Output() public imageItems: ImageItem[] = [];
    @Input() public contextMenu: MenuItem[];
    @Output() imageItemsChange = new EventEmitter<ImageItem[]>();

    isDragging = false;
    dragIndex: number | null = null;

    public divSrc: any;
    public base: boolean = true;
    private closest: string = '';
    public source: string;
    public target: string;

    constructor() {
    }

    public ngOnInit() {
        // console.log('ngOnInit', this.imageItems);
    }

    public ngOnChanges() {
        // console.log('ngOnChanges', this.imageItems);
    }


    public menuAction($event) {
        this.updateAction($event.action, $event.image.page);
    }

    private updateAction($aAction, $aPage) {
        this.imageItems.find(item => {
            if (item.page === $aPage) {
                if ($aAction === 'rotate') {
                    item.rotate = item.rotate + 90;
                    if (item.rotate === 360) {
                        item.rotate = 0;
                    }
                } else {
                    item.action = $aAction;
                }
            }
        });     
    }

    public allowDrop(ev) {
        ev.preventDefault();
    }        

    public dragEnter(ev) {
        if (ev.currentTarget !== this.divSrc) {
            this.verifyBorder(ev);
        }
    }

    public drag(ev) {
        this.divSrc = ev.currentTarget;
        this.base = true;
    }

    public dragOver(ev) {
        this.verifyBorder(ev);
    }

    public dragLeave (ev){
        this.setBorder(ev, 'none');
    }

    private verifyBorder(ev) {
    // if (ev.target.closest(this.closest) !== null) {            
    //     if (ev.target.closest(this.closest).style.border != "2px dotted black") {
            // this.setBorder(ev, '2px dotted black');
    //     }
    // }
    }

    private setBorder(ev, aValue) {
        // if (ev.target.closest(this.closest) !== null) {         
        //     ev.target.closest(this.closest).style.border = aValue;
        // }
    }

    public drop(ev) {
        let wSrc = -1;
        let wTrg = -1;
        let wNumPageOrigSrc = '';
        let wNumPageOrigTrg = '';
        ev.preventDefault();
        ev.stopPropagation();
        this.source = '';
        this.target = '';
        if (this.base === false) {
            return;
        }
        if (ev.currentTarget === this.divSrc) {
            // déplacement de la div sur sa position
            this.base = false;
        } else {       
            this.base = false;
            this.source = this.divSrc.id;
            this.target = ev.currentTarget.id;
        }
        wSrc = this.imageItems.findIndex((item) => {
            return item.page === this.source;
        });
        wTrg = this.imageItems.findIndex((item) => {
            return item.page === this.target;
        });
        if (wSrc !== -1 && wTrg !== -1 && wSrc >= 0 && wSrc < this.imageItems.length && wTrg >= 0 && wTrg < this.imageItems.length) {
            // Détection des pages originales, vérification si changement de page
            const numPageOrigSource = this.imageItems[wSrc].numPageOrig;
            const numPageOrigTarget = this.imageItems[wTrg].numPageOrig;
            this.imageItems[wSrc].numPageOrig = numPageOrigTarget;
            this.imageItems[wTrg].numPageOrig = numPageOrigSource;
            this.swapElements(this.imageItems, wSrc, wTrg);
        }
        this.divSrc.style.opacity = 'unset';
        this.dragLeave(ev);
    }

    private swapElements<T>(array: T[], i: number, j: number): void {
        [array[i], array[j]] = [array[j], array[i]];
    }

}